/**
 * Created by katarinababic on 11.6.25.
 */
import * as React from 'react';
import { WeekDayEntry } from '../../Model/Coach/Schedule/WeekDayEntry';
import { WeekDayEntryWorkout } from '../../Model/Coach/Schedule/WeekDayEntryWorkout';
import { WeekDayEntryActivityLog } from '../../Model/Coach/Schedule/WeekDayEntryActivityLog';
import { WeekDayEntryEvent } from '../../Model/Coach/Schedule/WeekDayEntryEvent';
import { WeekDayEntryMindfulnessUnit } from '../../Model/Coach/Schedule/WeekDayEntryMindfulnessUnit';
import { WorkoutDayCardWorkout } from './WorkoutDayCardWorkout';
import { WorkoutDayCardLoggedActivityContainer } from './WorkoutDayCardLoggedActivityContainer';
import { WorkoutDayCardEvent } from './WorkoutDayCardEvent';
import { WorkoutDayCardSubscribedEvent } from './WorkoutDayCardSubscribedEvent';
import { WorkoutDayCardMindfulnessUnit } from './WorkoutDayCardMindfulnessUnit';
import { WeekDayEntrySubscribedEvent } from '../../Model/Coach/Schedule/WeekDayEntrySubcribedEvent';
import { ScheduleEntryCard } from './ScheduleEntryCard';

export interface ScheduleEntryRendererProps {
  entry: WeekDayEntry;
  date?: string;
}

export const ScheduleEntryRenderer: React.FC<ScheduleEntryRendererProps> = ({ entry, date }) => {
  // Use unified card if entry has pre-resolved display properties from backend
  // This eliminates the need to fetch additional objects
  if (entry.title) {
    return <ScheduleEntryCard entry={entry} date={date} />;
  }

  // Fallback to specialized renderers for backwards compatibility
  if (entry.type === 'workout' && !(entry as WeekDayEntryWorkout).workout?.workoutLog) {
    return <WorkoutDayCardWorkout entry={entry as WeekDayEntryWorkout} />;
  } else if (entry.type === 'activityLog') {
    return <WorkoutDayCardLoggedActivityContainer entry={entry as WeekDayEntryActivityLog} />;
  } else if (entry.type === 'event') {
    return <WorkoutDayCardEvent entry={entry as WeekDayEntryEvent} />;
  } else if (entry.type === 'subscribedEvent') {
    return <WorkoutDayCardSubscribedEvent entry={entry as WeekDayEntrySubscribedEvent} />;
  } else if (entry.type === 'mindfulnessUnit') {
    return <WorkoutDayCardMindfulnessUnit entry={entry as WeekDayEntryMindfulnessUnit} />;
  }
  return null;
};
